import _ from 'lodash'
export * from './catalog'
export * from './reports'
export * from './workspace'
export * from './apollo'
export * from './site'
export * from './user'
export * from './nav'
export * from './dev'
export * from './sync'
export * from './sidebar'
export * from './c8'
export * from './config'
export * from './notifications'
export * from './comments'
export * from './tags'
export * from './jira'
export * from './app'
export {aws} from './aws'
export * from './imageBreakpoints'

import {PdfExportStore} from '@modules/pdf'
import {JiraStore} from '@stores/jira'
import {SocketIOStore} from './socketIO'
import {dev, DevStore} from '@modules/dev/DevStore'
import {FilterChipsToolbarStore} from '@modules/catalog/FilterChipsToolbar/store'
export {FilterChipsToolbarStore} from '@modules/catalog/FilterChipsToolbar/store'

import {TagsStore} from '@stores/tags'
import {autorun, reaction, trace, runInAction} from 'mobx'
import {MobxDevToolsStore} from './dev'
export {IDragDropElement, DragDropEventHandlers, DragDropInteraction, DropTargetType, IDropElement, IDragDropElementState} from './dragDrop'
import {DragDropStore} from '@stores/dragDrop'
import {ToJSOptions} from 'mobx/lib/api/tojs'
import utils from '../modules/common/utils'
import {C8Store} from '@stores/c8'
import {ConfigStore} from '@stores/config'
import {DeploymentsStore} from '@stores/dev'
import {SyncProgressStore} from '@stores/sync'
import {CurrentUserStore, UsersStore} from '@stores/user'
import {WorkspacesStore} from '@stores/workspace'
import { DexieConstructor } from 'dexie'
import {LoDashStatic} from 'lodash'
import {IAutorunOptions, IReactionOptions} from 'mobx/lib/api/autorun'
import {IWhenOptions} from 'mobx/lib/api/when'
import {IReactionDisposer, IReactionPublic, Lambda} from 'mobx/lib/internal'
import {ExportStore} from './export'
import {ElasticSearchStore} from '@stores/elasticsearch'
import {icons, ui, UIStore} from '@stores/ui'
import {SiteStore} from './site'
import {ApolloStore} from './apollo'
import {UserNotificationsStore} from './notifications'
import {CatalogPresetsStore, CatalogStore, GroupByStore, FlexLayoutStore} from './catalog'
export {CatalogRootFlexLayoutStoreContext} from './catalog'
import {NavStore} from './nav'
import {LibraryStore, SidebarStore, FilterStore} from '@design-board/stores'
import {VLPStore, placeholderImages} from './vlp'
import {StringsStore} from './StringsStore'
import {auth, error, AuthStore} from '@utils'
import { CommentsStore } from './comments'
import {ContextMenuStore, DataGridStore} from '@design-board'
import { StoresInstance } from './StoresInstance'
import { ReportsStore } from './reports'
import { AppStore } from './app'
export {StoresInstance} from './StoresInstance'

export interface Stores {
  app: AppStore
  storeId?: string
  authStore: AuthStore
  apollo: ApolloStore
  c8: C8Store
  comments: CommentsStore
  config: ConfigStore
  dev?: DevStore
  jira?: JiraStore
  sidebar: SidebarStore
  library: LibraryStore
  nav: NavStore
  site: SiteStore
  strings: StringsStore
  deployments: DeploymentsStore
  syncProgress: SyncProgressStore
  catalog?: CatalogStore,
  vlp?: VLPStore
  ui?: UIStore
  filter?: FilterStore
  flexLayout?: FlexLayoutStore
  es?: ElasticSearchStore
  export?: ExportStore
  dragDrop?: DragDropStore
  dexie?: DexieConstructor
  workspaces?: WorkspacesStore
  users: UsersStore
  currentUser: CurrentUserStore
  groupBy?: GroupByStore
  userNotifications?: UserNotificationsStore
  contextMenu?: ContextMenuStore
  reports?: ReportsStore
  nest: SocketIOStore
  tags: TagsStore
  thirdparty: {
    toJS<T>(source: T, options?: ToJSOptions): T,
    _: LoDashStatic,
    autorun: (view: (r: IReactionPublic) => any, opts?: IAutorunOptions) => IReactionDisposer,
    reaction<T>(expression: (r: IReactionPublic) => T, effect: (arg: T, r: IReactionPublic) => void, opts?: IReactionOptions): IReactionDisposer,
    when(predicate: () => boolean, effect: Lambda, opts?: IWhenOptions): IReactionDisposer,
    runInAction<T>(name: string, block: () => T): T
  },
  mobxDevTool?: MobxDevToolsStore
  error?: typeof error
  log?
  auth?: typeof auth
  utils?: typeof utils
  filterChipsToolbar?: FilterChipsToolbarStore
  presets?: CatalogPresetsStore
  datagrid?: DataGridStore
  pdf?: PdfExportStore
}

/**
 * We should ideally have instances of all stores created in one file and
 * then import them anywhere in application so that instance is singleton
 **/
const stores = new StoresInstance('App-Wide Global Stores', null, 'global')

export const createGlobalStores = () => {
  return new StoresInstance('App-Wide Global Stores', null, 'global')
}
export const globalStores = createGlobalStores()

export {
  LibraryStore, SidebarStore, ContextMenuStore,
  icons,
  VLPStore, placeholderImages, ui, dev
}

export {GroupByGroupStore, useGroupByGroupStore} from '@design-board/stores'
export const prettyPrint = o => JSON.stringify(o, null, 1)

const ADD_GLOBALS_TO_WINDOW_THIS_IS_MEMORY_INTENSIVE = PLATFORM === 'darwin'
if (DEBUG && ADD_GLOBALS_TO_WINDOW_THIS_IS_MEMORY_INTENSIVE) {
// window.centric = stores
  window['prettyPrint'] = prettyPrint
  window['autorun'] = autorun
  window['runInAction'] = runInAction
  window['reaction'] = reaction
  window['globalStores'] = globalStores
  window['trace'] = trace

  _.keys(stores).forEach((k) => {
    if (!window[k]) {
      window[k] = stores[k]
    }
  })
}


// WEBPACK FOOTER //
// ./src/stores/index.ts